import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=764d1605&scoped=true&"
import script from "./Billings.vue?vue&type=script&lang=js&"
export * from "./Billings.vue?vue&type=script&lang=js&"
import style0 from "./Billings.vue?vue&type=style&index=0&id=764d1605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d1605",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContainer,VContent})
